import { MobilePopup as AdvoxMobilePopup } from 'AdvoxComponent/MobilePopup/MobilePopup.component';
import Icons from 'Component/Icons';

import TypographyHeader from '../TypographyHeader';

import './MobilePopup.override.style.scss';

/** @namespace Pwa/Component/MobilePopup/Component */
export class MobilePopup extends AdvoxMobilePopup {
    render() {
        const { title, handleMobilePopup, isOpen, icon, children, isSpacing } = this.props;

        const chatIframes = document.querySelectorAll('#bhr-items iframe');

        chatIframes.forEach((chatIframe) => {
            chatIframe.style.zIndex = isOpen ? '1 !important' : '2147480000';
        });

        return (
            <div block="MobilePopup" mods={{ visible: isOpen }}>
                <div block="MobilePopup" elem="TopBar">
                    <div block="MobilePopup" elem="Title">
                        {icon && <Icons name={icon} width="24" height="24" fill="#fff" />}
                        <TypographyHeader variant="small" tag="p">
                            {title}
                        </TypographyHeader>
                    </div>
                    <div block="MobilePopup" elem="CloseBtn" onClick={handleMobilePopup}>
                        <Icons name="close" width="30" height="30" fill="#fff" />
                    </div>
                </div>
                <div block="MobilePopup" elem="Content" mods={{ noSpacing: isSpacing }}>
                    {children}
                </div>
            </div>
        );
    }
}

export default MobilePopup;
